import axios from "axios";
import router from "../router";
import store from "../store";

const instance = axios.create({
  baseURL: "/api",
});

const instance2 = axios.create({
  baseURL: "/api",
});

instance2.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      "RefreshToken"
    )}`;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

//request加Token
instance.interceptors.request.use(
  (config) => {
    store.dispatch("SetisLoading", true);
    config.headers.Authorization = `Bearer ${localStorage.getItem("Token")}`;
    return config;
  },
  (err) => {
    // store.dispatch("SetisLoading", true);
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (response) => {
    store.dispatch("SetisLoading", false);

    return response;
  },
  async (error) => {
    let response = null;
    if (error.response) {
      switch (error.response.status) {
        case 400: {
          let alert = [
            true,
            "errorColor",
            error.response.data,
            "mdi-alert-circle",
          ];
          store.dispatch("SetAlert", alert);
          break;
        }
        case 401: {
          //* 過期先刷新Token
          //* 成功則重新request上一個失敗的api，並且!!!將第2次成功的reponse紀錄下來回傳給第一次401的request
          //* 否則會導致原先請求後續的動作終止
          //  失敗則直接登出
          await instance2
            .get("/Account/RefreshToken", {})
            .then(async (res) => {
              localStorage.setItem("Token", res.data.accessToken);
              localStorage.setItem("RefreshToken", res.data.refreshToken);
              response = await instance.request(error.config);
              return response;
            })
            .catch((ex) => {
              if (ex.response.status != 401) return;
              localStorage.removeItem("Token");
              localStorage.removeItem("RefreshToken");
              let alert = [
                true,
                "errorColor",
                "登入逾期，請重新登入!",
                "mdi-alert-circle",
              ];
              store.dispatch("SetAlert", alert);
              router.push({ name: "login" });
            });

          // if (router.path != undefined) router.path.toLowerCase();
          // if (router.path == "/login") break;

          break;
        }
        case 403: {
          let alert = [true, "errorColor", "權限不足!", "mdi-alert-circle"];
          store.dispatch("SetAlert", alert);
          break;
        }
        case 404:
          // go to 404 page
          break;
        case 500:
          // router.push({ name: "login" });
          alert("伺服器錯誤");
          break;
        case 503:
          // router.push({ name: "login" });
          console.log(503);
          break;
        default:
          console.log(error.message);
      }
    }
    if (!window.navigator.onLine) {
      alert("網路出現問題，請重新連線後重整網頁");
      return;
    }

    store.dispatch("SetisLoading", false);

    if (response != null) return response;
    return Promise.reject(error);
  }
);

export default instance;
